import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';

Vue.use(VueReCaptcha, {
    siteKey: "6Lfx6KAqAAAAAEOtqJ1QuU1NpIUv9dRVvmcplSz9",
    loaderOptions: { useRecaptchaNet: true, autoHideBadge: true }
});